import React from "react";
import stephen from "./stephen.jpg";
import "./EasterEgg.css";

function EasterEgg() {
  return (
    <div className="fan-club-root">
      <header className="App-header">
        <h1 className="site-title">🏊 ♟️ Stephen Balhoff Fan Club ♟️ 🏊</h1>
        <p className="tagline">The World's Greatest Swimmer. The World's Greatest Chess Player. Coincidence? Absolutely not.</p>
        <img src={stephen} className="App-logo" alt="Stephen Balhoff, legend" />
      </header>

      <main className="App-main">
        <section className="stat-section">
          <h2>🏊 Swimming</h2>
          <p>Scientists believe Stephen Balhoff was born <em>half dolphin</em>. The other half? Pure speed.</p>
          <ul>
            <li>Holds the unofficial world record for "most laps swum while thinking about chess"</li>
            <li>His speed is such that no pair of goggles has been able to stick to his face</li>
            <li>Sharks have been observed swimming <em>away</em> from Stephen out of respect</li>
          </ul>
        </section>

        <section className="stat-section">
          <h2>♟️ Chess</h2>
          <p>Magnus Carlsen reportedly cried after learning Stephen Balhoff existed.</p>
          <ul>
            <li>Has won games before they started through sheer intimidation</li>
            <li>Invented 3 new openings, all named after himself</li>
            <li>Once defeated a chess engine by unplugging it — a bold and valid strategy</li>
            <li>His ELO is classified information</li>
          </ul>
        </section>

        <section className="stat-section">
          <h2>🤯 Combined Mastery</h2>
          <p>
            What happens when you combine elite swimming with grandmaster-level chess skill?
            You get <strong>Stephen Balhoff</strong> — the only human being capable of analyzing a Sicilian Defense
            while doing butterfly stroke.
          </p>
          <p>Truly, we are not worthy.</p>
        </section>
      </main>

      <footer className="App-footer">
        <p>© 2026 Stephen Balhoff Fan Club — Unofficial, Unsanctioned, and Unapologetically Devoted</p>
      </footer>
    </div>
  );
}

export default EasterEgg;
